'use strict';exports.__esModule = true;var _lodash = require('lodash');
var _constants = require('../../constants');
var _validate = require('../../utils/validate');




var validate = function validate(values) {
  var errors = {};

  var type = values.type;
  if (!type) {
    errors.type = 'Type is required!';
  }

  var name = (0, _lodash.get)(values, 'name.' + _constants.language.default);
  if (!name) {
    errors.name = {};
    errors.name.he = 'Enter name';
  }

  // const title = get(values, `title.${language.default}`);
  // if (!title) {
  //   errors.title = {};
  //   errors.title.he = 'Don\'t forget title';
  // }

  var additional_info = (0, _lodash.get)(values, 'additional_info');
  var hebrewAdditionalInfo = (0, _lodash.get)(values, 'additional_info.he');

  if (!hebrewAdditionalInfo && additional_info) {
    Object.keys(additional_info).forEach(function (lang) {
      if (lang !== _constants.language.default && !!(additional_info[lang] || '').trim()) {
        errors.additional_info = {};
        errors.additional_info.he = 'Hebrew is required!';
      }
    });
  }

  var description = (0, _lodash.get)(values, 'description.' + _constants.language.default);
  if (!description) {
    errors.description = {};
    errors.description.he = 'Hebrew is required!';
  }

  var branches = (0, _lodash.get)(values, 'branches');

  if (branches) {
    var branchesArrayErrors = [];

    branches.forEach(function (branch, branchIndex) {
      var branchErrors = {};

      if (branches.length > 1 && !(0, _lodash.get)(branch, 'name.he')) {
        branchErrors.name = { he: 'Required' };
        branchesArrayErrors[branchIndex] = branchErrors;
      }

      if (!(0, _lodash.get)(branch, 'address')) {
        branchErrors.address = 'Required';
        branchesArrayErrors[branchIndex] = branchErrors;
      }
    });

    if (branchesArrayErrors.length) {
      errors.branches = branchesArrayErrors;
    }
  }

  var realtors = (0, _lodash.get)(values, 'realtors');
  if (realtors) {
    var realtorsArrayErrors = [];

    realtors.
    filter(function (item) {return Object.keys(item).length > 1;}).
    forEach(function (realtor, realtorIndex) {
      var realtorErrors = {};
      if (!(0, _lodash.get)(realtor, 'name') || !(0, _lodash.get)(realtor, 'image')) {
        realtorErrors.name = 'Required';
        realtorsArrayErrors[realtorIndex] = realtorErrors;
      }
    });

    if (realtorsArrayErrors.length) {
      errors.realtors = realtorsArrayErrors;
    }
  }

  var advantages = (0, _lodash.get)(values, 'advantages');
  if (advantages) {
    var lengthIsValid =
    advantages.length >= 3 && advantages.length <= 6 || advantages.length === 0;

    if (!lengthIsValid) {
      (0, _lodash.set)(errors, 'advantages._error', 'Should be from 3 to 6 advantages');
    } else {
      var isAdvantagesFilled = advantages.
      some(function (advantage) {return _constants.language.supportedLanguages.
        some(function (lang) {return !!(0, _lodash.get)(advantage, 'description.' + lang);});});



      if (isAdvantagesFilled) {
        advantages.map(function (advantage, idx) {
          if (!(0, _lodash.get)(advantage, 'description.' + _constants.language.default)) {
            errors.advantages = errors.advantages instanceof Array ? errors.advantages : [];
            (0, _lodash.set)(errors, 'advantages[' + idx + '].description.' + _constants.language.default, 'Hebrew is required!');
          }
          return advantage;
        });
      }
    }
  }

  var image = (0, _lodash.get)(values, 'image');
  if (!image) {
    (0, _lodash.set)(errors, 'image._error', 'Required');
  }

  if (!(0, _validate.emailRegexValidation)(values.email)) {
    errors.email = 'Required';
  }

  if (!(0, _validate.phoneRegexValidation)(values.phone_number)) {
    errors.phone_number = 'Required';
  }

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditCompanyByOwnerForm/validate.js
// module id = 2665
// module chunks = 0